import actions from "./actions";
import store from "store";
const STORED_SETTINGS = (storedSettings) => {
  const settings = {};
  Object.keys(storedSettings).forEach((key) => {
    const item = store.get(`app.settings.${key}`);
    settings[key] = typeof item !== "undefined" ? item : storedSettings[key];
  });
  return settings;
};
const initialState = {
  ...STORED_SETTINGS({
    project: null,
    projectSelected: false,
    branch: null,
    user: null,
    wishlist: {},
  }),
  // project: null,
  // projectSelected:false,
  // store: [],
};

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    case actions.SET_USER_TABLE_COLUMNS:
      const { table, columns } = action.payload;
      return { ...state, user: {
        ...state.user,
        user_selected_columns: {
          ...state.user?.user_selected_columns ?? {},
          [table]: columns.map(col => ({
            title: col.title,
            key: col.key,
            selected: col.selected,
          })),
        }
      } };
    case actions.SET_WISHLIST:
      const { projectId, items } = action.payload;
      console.log("i-log> store state set", projectId, items);
      return { ...state, wishlist: {
        ...state.wishlist,
        [projectId]: items
      } };
    default:
      return state;
  }
}
